import { NgModule } from '@angular/core';
import { NbCardModule, NbIconModule, NbInputModule, NbToggleModule, NbActionsModule, NbSpinnerModule, NbTreeGridModule } from '@nebular/theme';

import { ThemeModule } from '../../@theme/theme.module';
import { FormsModule } from '@angular/forms';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { routedComponents, SettingRoutingModule } from './settings-routing.module';
import { SettingStatComponent } from './setting-stat/setting-stat.component';
import { SettingPageComponent } from './setting-page/setting-page.component';
import { SettingNetworkComponent } from './setting-network/setting-network.component';
import { SettingMenuComponent } from './setting-menu/setting-menu.component';
import { SettingGeneralComponent } from './setting-general/setting-general.component';


@NgModule({
  imports: [
    NbCardModule,
    NbIconModule,
    NbInputModule,
    SettingRoutingModule,
    ThemeModule,
    FormsModule,
    NbToggleModule,
    NgbModule,
    NgMultiSelectDropDownModule,
    NbActionsModule,
    NbSpinnerModule,
  ],
  entryComponents: [
    SettingStatComponent,
    SettingPageComponent,
    SettingNetworkComponent,
    SettingMenuComponent,
    SettingGeneralComponent,
  ],
  declarations: [
    SettingStatComponent,
    SettingPageComponent,
    SettingNetworkComponent,
    SettingMenuComponent,
    SettingGeneralComponent,
    ...routedComponents,
  ],
})
export class SettingsModule { }
